import './twoColumnsLeftTextImage.css'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {renderOptions} from "../../../utils/generals"

const TwoColumnsLeftTextImage = (props) => {

    const loadMedia = () => {
        if (props.data.image) {
          return (
            <div
              className="col-md-6  col-img-two-col  "
              style={{ backgroundImage: `url(${props.data.image?.url})` }}
            ></div>
          );
        } else if (props.data.video) {
          return (
            <div className="col-md-6  col-img-two-col  ">
              <video controls width="100%" height="80%">
                <source src={props.data.video.url} type="video/mp4"></source>
                Your browser does not support the video tag.
              </video>
            </div>
          );
        } else if (props.data.videoUrl) {
          return (
            <div className="col-md-6  col-img-two-col  ">
              <iframe
                id="ytplayer"
                title="video tigo"
                type="text/html"
                width="100%"
                height="90%"
                src={props.data.videoUrl}
                frameborder="0"
              ></iframe>
            </div>
          );
        }
      };

    return(
        <div className="container-fluid container-two-col-text-image-left ">
            <div className="container cols-container d-flex align-items-center  justify-content-center p-2">
                <div className="row  row-cols  col-12">
                    <div className=" text-col col-md-6  p-4">
                        { documentToReactComponents(props.data.leftText.json, renderOptions)}
                    </div>
                    {/* <div className="col-md-6  col-img-two-col " style={{ backgroundImage: `url(${props.data.image?.url})` }}>
                        
                    </div> */}
                    {loadMedia()}
                </div>
            </div>
        </div>
    )
}

export default TwoColumnsLeftTextImage;